export function pointDist(from, to) {
	return ((to[0] - from[0]) ** 2 + (to[1] - from[1]) ** 2) ** 0.5
}

export function toCartesian([disp, angle]) {
	const x = disp * Math.cos(angle)
	const y = disp * Math.sin(angle)
	return [x, y]
}
